import React from "react";
import { useLocation } from "react-router-dom";
import ReportGodaPark from "../../blogs/ReportGodaPark";
import Page from "../../components/Page";
const BASE_ROUTE = "/reports";

const NotFoundPage = () => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>Oops! Looks like you've stumbled upon a page that doesn't exist.</p>
    </div>
  );
};

const Reports = () => {
  const loc = useLocation();

  const renderBlog = () => {
    console.log("AAAAAAAAAAA ", loc.pathname);
    switch (loc.pathname) {
      case BASE_ROUTE + "/goda-park":
        return <ReportGodaPark />;
      default:
        return <NotFoundPage />;
    }
  };

  return <Page>{renderBlog()}</Page>;
};

export default Reports;
